import GoogleAnalytics from 'react-ga'
import GoogleTagManager from 'react-gtm-module'
import { hotjar as HotJar } from 'react-hotjar'

/**
 * To initialize the analytics tools.
 */
const initializeAnalytics = ({ gaKey, gtmId, hotjarId, hotjarSV } = {}) => {
  if (gaKey) {
    GoogleAnalytics.initialize(gaKey)
  }

  if (gtmId) {
    GoogleTagManager.initialize({ gtmId })
  }

  if (hotjarId && hotjarSV) {
    HotJar.initialize(hotjarId, hotjarSV)
  }
}

export default initializeAnalytics
